import React, {Component} from 'react';
import { SideNav, Nav } from "react-sidenav";
import {Link} from 'react-router-dom';
import MetisMenu from 'react-metismenu';
import RouterLink from 'react-metismenu-router-link';
import { Link2, Plane, Route as RouteIcon, Car, Package, Truck, Warehouse, UserCheck, Building2, ShieldCheck, CalendarDays, Map, PieChart, Users, Layers, Boxes, FileText, X } from 'lucide-react';
//import {MENUITEMS} from '../../../constants/menu'

// Import custom components
//import UserPanel from './user-panel.component';

// Ordered most-specific-keyword-first: matches against the menu item's own
// name so real pages get a meaningful icon instead of one generic glyph
// repeated on every row. Anything that doesn't match anything sensible here
// falls back to a neutral default icon (see renderSubIcon) instead.
const SUB_ICON_RULES = [
    { test: /nexa/i, Icon: Link2 },
    { test: /courier/i, Icon: Plane },
    { test: /route/i, Icon: RouteIcon },
    { test: /vehicle/i, Icon: Car },
    { test: /freight/i, Icon: Package },
    { test: /transporter/i, Icon: Truck },
    { test: /hub/i, Icon: Warehouse },
    { test: /consignee/i, Icon: UserCheck },
    { test: /department/i, Icon: Building2 },
    { test: /role/i, Icon: ShieldCheck },
    { test: /order/i, Icon: CalendarDays },
    { test: /state/i, Icon: Map },
    { test: /share of business|business/i, Icon: PieChart },
    { test: /user/i, Icon: Users },
    { test: /master/i, Icon: Layers },
    { test: /load management/i, Icon: Boxes },
];

function getSubIcon(name) {
    if (!name) return null;
    var rule = SUB_ICON_RULES.find((r) => r.test.test(name));
    return rule ? rule.Icon : null;
}

class Sidebar extends Component {
    constructor(props){
        super(props);
        this.state={
            selectedPath: "1",
            mainmenu: null,
        };
    }
   // state = {  };
    onItemSelection = (arg, e)=> {
        this.setState({ selectedPath: arg.path });
    };

    // The backend-driven menu list has occasionally shipped the same top-level
    // entry (e.g. "Load Management") twice - guard against that here instead of
    // rendering it twice.
    dedupeMenu(items) {
        var seen = [];
        return (items || []).filter((item) => {
            var key = (item.name || item.group_heading || "").trim().toLowerCase();
            if (!key) return true;
            if (seen.indexOf(key) !== -1) return false;
            seen.push(key);
            return true;
        });
    }

    componentWillMount() {

    }
    componentDidMount() {
        var currentUrl = window.location.pathname;
        // setState() is async, so this.state.mainmenu would still read as the
        // constructor's null right after calling it below - operate on this
        // local variable instead of the not-yet-updated state.
        var MENUITEMS = this.state.mainmenu;
        if (!MENUITEMS) {
            let menuslist = localStorage.getItem('usermenus');
            if (menuslist) {
                MENUITEMS = this.dedupeMenu(JSON.parse(menuslist));
                this.setState({
                    mainmenu:MENUITEMS
                })
            }
        }
        if (MENUITEMS) {
            MENUITEMS.filter(items => {
                if (!items.children){
                    if (items.path === currentUrl)
                        this.setNavActive(items, MENUITEMS)
                    return false
                }
                items.children.filter(subItems => {
                    if (subItems.path === currentUrl)
                        this.setNavActive(subItems, MENUITEMS)
                    if (!subItems.children) return false
                    subItems.children.filter(subSubItems => {
                        if (subSubItems.path === currentUrl)
                            this.setNavActive(subSubItems, MENUITEMS)
                    })
                })
            })
        }

    }

    // Recursively clears the active flag on every leaf (childless) item in the
    // tree - group headers (which have children) are left alone here, the
    // ancestor-marking loop in setNavActive handles those.
    deactivateAllLeaves(items) {
        (items || []).forEach((node) => {
            if (node.children && node.children.length > 0) {
                this.deactivateAllLeaves(node.children);
            } else {
                node.active = false;
            }
        });
    }

    setNavActive(item, menuTreeOverride) {
        var sourceTree = menuTreeOverride || this.state.mainmenu;
        let MENUITEMS = [...sourceTree];
        var isLeaf = !(item.children && item.children.length > 0);
        if (isLeaf) {
            // Selecting a real page - only one leaf across the whole tree should
            // ever read as active, otherwise a previously-selected page (e.g.
            // "Air Courier Configuration") stays highlighted after picking a
            // different one ("Hub City Freights"), since nothing below resets
            // sibling leaves - only the two group levels above them.
            this.deactivateAllLeaves(MENUITEMS);
        }
        if (sourceTree) {

            MENUITEMS.filter(menuItem => {
                if(menuItem != item)
                    menuItem.active = false
                if(menuItem.children && menuItem.children.includes(item))
                    menuItem.active = true
                if(menuItem.children){
                    // menuItem.children.filter(submenuItems => {
                    //     if(submenuItems.children && submenuItems.children.includes(item))
                    //         menuItem.active = true
                    //     if(submenuItems != item)
                    //         submenuItems.active = false
                    // })

                    menuItem.children.filter(submenuItems => {
                        var isDirectParentOfItem = submenuItems.children && submenuItems.children.includes(item)
                        if(isDirectParentOfItem)
                        {
                            //console.log("Step1")
                            menuItem.active = true
                            // submenuItems is the immediate parent of the clicked item (e.g.
                            // "Masters" when "Route Configurations" was clicked) - it must stay
                            // open, not get deactivated below just because it isn't the item itself.
                            submenuItems.active = true
                        }
                        else if(submenuItems != item)
                        {
                            //console.log("Step2")
                            submenuItems.active = false
                            //this.props.context.openCloseSidebar();
                        }
                        if(submenuItems.children && submenuItems.children.length > 0)
                        {
                            //console.log("Step3")
                            if(submenuItems.children.includes(item) == true)
                            {
                                //console.log("Step4")
                                this.onHideSidebar();
                            }
                        }
                        else{
                        // console.log("Step5")
                            if(item.is_link == true)
                            {
                            // console.log("Step6")
                                if(menuItem.children.includes(item) == true)
                                {
                                    //console.log("Step7")
                                    this.onHideSidebar();
                                }
                            }

                        }
                            //console.log("submenuItems ", submenuItems)
                    })
                }
            })
        }
        if (isLeaf) {
            // A leaf is a real page, not a toggleable group - clicking it (or
            // landing on it after a refresh) should always select it, not flip
            // it back off if it happened to already be active.
            item.active = true
        } else {
            item.active = !item.active
        }

        this.setState({
            mainmenu:MENUITEMS
        })


    }

    // Prefer a real icon if the menu record has one, otherwise fall back to a
    // Lucide icon matched against the item's own name - and if nothing matches
    // sensibly, render no icon at all rather than a repeated generic glyph.
    // An empty children array (e.g. []) is still truthy in JS, so a plain
    // `item.children ?` check would wrongly show an expand caret on a leaf
    // item like "Load Summary" that has no actual sub-items.
    hasChildren(item) {
        return !!(item.children && item.children.length > 0);
    }

    renderSubIcon(item) {
        // item.icon isn't trustworthy here - most backend menu records share
        // the same generic value across every sub-item (that's the suitcase
        // that was showing up everywhere), so it's ignored at this level.
        // Name match first, and a plain neutral icon for anything that
        // doesn't match a specific keyword, instead of leaving it blank.
        var Icon = getSubIcon(item.name) || FileText;
        return <Icon size={14} className="sidebar-sub-icon" />;
    }

    onCloseSidebar(){
        document.querySelector(".page-body-wrapper").classList.add('sidebar-close');

        //document.querySelector(".sidebaricon").classList.remove('show-n');
        //document.querySelector(".sidebaricon").classList.add('show-m');
        document.querySelector(".siconbg").classList.remove('show-m');
        document.querySelector(".siconbg").classList.add('show-n');
        document.querySelector(".sidemenu").classList.remove('l20n');
        document.querySelector(".sidemenu").classList.add('whgb');
        document.querySelector(".sidebrclose").classList.remove('show-n');
        document.querySelector(".sidebrclose").classList.add('show-m');
        //console.log(document.querySelector(".sidebrclose").classList);
        var sidebaricon = document.querySelector(".sidebaricon");
        // if(sidebaricon.classList.contains('show-n'))
        // {
            //console.log("Yr")
            document.querySelector(".sidebaricon").classList.remove('show-n');
            document.querySelector(".sidebaricon").classList.remove('show-n');
            document.getElementById("pbody").classList.add('in');
            document.getElementById("pbody").classList.remove('extra');
        // }
        // if(sidebaricon.classList.contains('show-m'))
        // {
        //     document.querySelector(".sidebaricon").classList.remove('show-m');
        //     document.querySelector(".sidebaricon").classList.add('show-n');
        // }
        // if(document.querySelector(".sidebrclose").hasClass('show-m'))
        // {
        //     document.querySelector(".sidebrclose").classList.remove('show-m');
        //     document.querySelector(".sidebrclose").classList.add('show-n');
        // }
    }
    onHideSidebar(){
        document.querySelector(".page-body-wrapper").classList.add('sidebar-close');
        document.querySelector(".sidebaricon").classList.remove('show-n');
        document.querySelector(".sidebaricon").classList.add('show-m');
        document.querySelector(".siconbg").classList.remove('show-m');
        document.querySelector(".siconbg").classList.add('show-n');
        document.querySelector(".sidemenu").classList.remove('l20n');
        document.querySelector(".sidemenu").classList.add('whgb');
        document.querySelector(".sidebrclose").classList.remove('show-n');
        document.querySelector(".sidebrclose").classList.add('show-m');
    }
    render() {
        const theme = {
            selectionColor: "#C51162"
        };
        //console.log("IN render, 1 this.state.mainmenu ", this.state.mainmenu);
        let mainmenu = null;
        if (!this.state.mainmenu) {
           // console.log("IN Render, 2 this.state.mainmenu ", this.state.mainmenu);
            let menuslist = localStorage.getItem('usermenus');
            if (menuslist) {
                const MENUITEMS = this.dedupeMenu(JSON.parse(menuslist));
                this.setState({
                    mainmenu:MENUITEMS
                })
            }
        }
       // console.log("this.state.mainmenu ", this.state.mainmenu);
       var sideTitlecls = "";
       var sideHeadercls = "";
       if(localStorage.getItem("is_enmovil_transporter") == 1)
       {
            var sideTitlecls = "sideTitlecls";
            var sideHeadercls = "sideHeadercls";
       }
       if (this.state.mainmenu) {
            mainmenu = this.state.mainmenu.map((menuItem, i) =>
                <li className={`${menuItem.active?'active':''}`} key={i}>
                    { (menuItem.group_heading && menuItem.group_heading.toString().trim().toLowerCase() !== (menuItem.name || "").toString().trim().toLowerCase())?
                        <div className={"sidebar-title "+sideTitlecls}>{menuItem.group_heading}</div>
                        :''}
                    { (menuItem.is_link === false )?
                    <a className={"sidebar-header "+sideHeadercls} href="javascript:void(0)" onClick={() => this.setNavActive(menuItem)}>
                        <i className={`icon-${menuItem.icon}`}></i>
                        <span>{menuItem.name}</span>
                        <i className="fa fa-angle-right pull-right"></i>
                    </a>
                        :''}
                    { (menuItem.is_link === true )?
                        <Link
                            to={`${process.env.PUBLIC_URL}${menuItem.path}`}
                            className={`sidebar-header ${menuItem.active?'Active ':' '}`+sideHeadercls}
                            onClick={() => {
                                this.setNavActive(menuItem);
                                document.getElementById("pbody").classList.add("in");
                                document.getElementById("pbody").classList.remove("extra")
                            }}
                            >
                            <i className={`icon-${menuItem.icon}`}></i><span>{menuItem.name}</span>
                            {this.hasChildren(menuItem)?
                            <i className="fa fa-angle-right pull-right"></i>:''}
                        </Link>
                        :''}
                    {this.hasChildren(menuItem)?
                    <ul
                    className={`sidebar-submenu ${menuItem.active?'menu-open':''}`}
                    style={ menuItem.active?{ opacity: 1, transition: 'opacity 500ms ease-in' }: {}}
                    >
                        {menuItem.children.map((childrenItem, index) =>
                            <li key={index} className={this.hasChildren(childrenItem)?childrenItem.active?'active':'':''}>
                                { (childrenItem.is_link === false )?
                                <a href="javascript:void(0)" className={this.hasChildren(childrenItem)?'sidebar-group-label':''} onClick={() => this.setNavActive(childrenItem)} >
                                    {this.renderSubIcon(childrenItem)}
                                    <span>{childrenItem.name}</span>
                                    {this.hasChildren(childrenItem)? <i className="fa fa-angle-down sidebar-caret"></i> : ''}
                                    </a>
                                    :''}

                                { (childrenItem.is_link === true )?
                                    <Link
                                        to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                                        className={(childrenItem.active?'active ':'')+(this.hasChildren(childrenItem)?'sidebar-group-label':'')}
                                        onClick={() => {
                                            this.setNavActive(childrenItem)
                                            document.getElementById("pbody").classList.add("in");
                                document.getElementById("pbody").classList.remove("extra")
                                        }}
                                    >
                                        {this.renderSubIcon(childrenItem)}
                                        <span>{childrenItem.name}</span>
                                        {this.hasChildren(childrenItem)? <i className="fa fa-angle-down sidebar-caret"></i> : ''}
                                    </Link>
                                    :''}
                                {this.hasChildren(childrenItem)?
                                    <ul className={`sidebar-submenu ${childrenItem.active?'menu-open':''}`}>
                                        {childrenItem.children.map((childrenSubItem, key) =>
                                            <li className={childrenSubItem.active?'active':''} key={key}>
                                                {/* { (childrenSubItem.is_link === true )?
                                                    <Link
                                                        to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                                                        className={childrenSubItem.active?'active':''}
                                                    >
                                                        <i className="fa fa-angle-right"></i>{childrenSubItem.name}</Link>
                                                :''} */}

                                                { (childrenSubItem.is_link === false )?
                                                    <a href="javascript:void(0)" onClick={() => this.setNavActive(childrenSubItem)} >
                                                        {this.renderSubIcon(childrenSubItem)}
                                                        {childrenSubItem.name}</a>
                                                :''}
                                                { (childrenSubItem.is_link === true )?
                                                    <Link
                                                        to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                                                        className={childrenSubItem.active?'active':''}
                                                        onClick={() => {
                                                            this.setNavActive(childrenSubItem)
                                                            document.getElementById("pbody").classList.add("in");
                                document.getElementById("pbody").classList.remove("extra")
                                                        }}
                                                    >
                                                        {this.renderSubIcon(childrenSubItem)}
                                                        {childrenSubItem.name}</Link>
                                                :''}

                                            </li>
                                            )}
                                    </ul>
                                    :''}
                            </li>
                        )}
                    </ul>
                        :''}
                </li>
            )
        }
        var sideMenuCls = "";
        if(localStorage.getItem("is_enmovil_transporter") == 1)
        {
            var sideMenuCls = "sideMenuCls";
        }
        return (
            <div className={"page-sidebar custom-scrollbar page-sidebar-open "+sideMenuCls} style={{overflowX: "hidden"}}>

                <div className="sidebar-close-row">
                    <a href="javascript:void(0)" className="sidebar-close-x" onClick={this.onCloseSidebar.bind(this)} title="Collapse sidebar">
                        <X size={16} />
                    </a>
                </div>

                <ul className="sidebar-menu">
                    {mainmenu}
                </ul>
            </div>
        );
    }
}

export default Sidebar
